import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useCatalog } from "@/context/CatalogContext";
import AccessDenied from "@/components/AccessDenied";

function Syncing({ label = "Sincronizando módulos…" }) {
  return (
    <div className="min-h-[320px] flex items-center justify-center" data-testid="catalog-syncing">
      <div className="text-center">
        <div className="mx-auto h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
        <p className="mt-3 text-xs text-muted-foreground">{label}</p>
      </div>
    </div>
  );
}

/**
 * Rota protegida por uma entrada do Catálogo de Módulos.
 *
 * `entry`: chave do catálogo (ex.: "plano_acao"). `action` opcional exige
 * também uma ação do Engine (ex.: criar ocorrência). Sem bypass por perfil:
 * o administrador também respeita módulos desabilitados na plataforma.
 */
export default function CatalogRoute({ entry, action, children }) {
  const { user, loading, can } = useAuth();
  const { loaded, byKey } = useCatalog();

  if (loading) return <Syncing label="Carregando sessão…" />;
  if (!user) return <Navigate to="/login" replace />;
  if (!loaded) return <Syncing />;

  const item = byKey[entry];
  if (!item?.available) {
    return <AccessDenied title={item?.label ? `${item.label} indisponível` : undefined} reason={item?.reason_label} />;
  }
  if (action && !can(action.module, action.action)) {
    return <AccessDenied reason="Seu perfil não possui esta operação." />;
  }
  return children;
}
